import { gql } from "@apollo/client";

const BUDGET_FIELDS = gql`
  fragment BudgetFields on Budget {
    id
    startDate
    endDate
    allocationInMillicents
    usageInMillicents
    warningThresholdInMillicents
    history {
      id
      createdAt
      createdBy {
        id
        fullName
      }
      type
      allocationInMillicents
    }
  }
`;

export const GET_LATEST_BUDGETS = gql`
  ${BUDGET_FIELDS}
  query getLatestBudgets {
    getLatestBudgets {
      id
      subaccount {
        id
        name
        slug
      }
      budget {
        ...BudgetFields
      }
    }
  }
`;

export const GET_BUDGETS_FOR_SUBACCOUNT = gql`
  ${BUDGET_FIELDS}
  query getBudgetsForSubaccount($input: GetBudgetsForSubaccountInput!) {
    getBudgetsForSubaccount(input: $input) {
      ...BudgetFields
    }
  }
`;

export const ENABLE_BUDGET_FOR_SUBACCOUNT = gql`
  mutation enableBudgetForSubaccount($input: EnableBudgetForSubaccountInput!) {
    enableBudgetForSubaccount(input: $input)
  }
`;

export const EDIT_BUDGET_FOR_SUBACCOUNT = gql`
  mutation editBudgetForSubaccount($input: EditBudgetForSubaccountInput!) {
    editBudgetForSubaccount(input: $input)
  }
`;

export const RESET_BUDGET_FOR_SUBACCOUNT = gql`
  mutation resetBudgetForSubaccount($input: ResetBudgetForSubaccountInput!) {
    resetBudgetForSubaccount(input: $input)
  }
`;

export const DISABLE_BUDGET_FOR_SUBACCOUNT = gql`
  mutation disableBudgetForSubaccount(
    $input: DisableBudgetForSubaccountInput!
  ) {
    disableBudgetForSubaccount(input: $input)
  }
`;
